/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create or update institute information
 * @export
 * @interface UpsertInstituteInformation
 */
export interface UpsertInstituteInformation {
    /**
     * Message displayed at the top of the institute's page
     * @type {string}
     * @memberof UpsertInstituteInformation
     */
    generalMessage?: string;
}

/**
 * Check if a given object implements the UpsertInstituteInformation interface.
 */
export function instanceOfUpsertInstituteInformation(value: object): value is UpsertInstituteInformation {
    return true;
}

export function UpsertInstituteInformationFromJSON(json: any): UpsertInstituteInformation {
    return UpsertInstituteInformationFromJSONTyped(json, false);
}

export function UpsertInstituteInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertInstituteInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'generalMessage': json['generalMessage'] == null ? undefined : json['generalMessage'],
    };
}

export function UpsertInstituteInformationToJSON(json: any): UpsertInstituteInformation {
    return UpsertInstituteInformationToJSONTyped(json, false);
}

export function UpsertInstituteInformationToJSONTyped(value?: UpsertInstituteInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generalMessage': value['generalMessage'],
    };
}

